import {Component, QueryList, ViewChildren, ViewEncapsulation, OnInit, ViewChild, OnDestroy} from "@angular/core";
import {Table, TableColResizeEvent, TableLazyLoadEvent} from "primeng/table";
import { HttpClient, HttpParams } from "@angular/common/http";
import { env } from "@environments/environment";
import { PAGINATION_OPTIONS } from "@app/components/supplies/supplies.component";
import { Router } from "@angular/router";
import { DataService } from "@app/services/data.service";
import { Tooltip } from "primeng/tooltip";
import { StatusTranslatorService } from "@app/services/status.translator.service";
import {FilterService} from "@app/services/filter.service";
import {DistributionsTable} from "@app/ui_models/model-dto";
import {Subscription} from "rxjs";
import {DatePipe} from "@angular/common";

@Component({
  selector: "app-distributionsMzu",
  templateUrl: "./distributions.mzu.component.html",
  styleUrls: ["/distributions.mzu.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DistributionsMzuComponent implements OnInit, OnDestroy {

  constructor(private http: HttpClient,
              private router: Router,
              public statusTranslatorService: StatusTranslatorService,
              public filter: FilterService,
              public dataService: DataService) {}

  @ViewChildren(Tooltip) tooltips!: QueryList <Tooltip>;

  distributions: DistributionsTable[] = [];
  selectedPageNumber = 1;
  pageSize = 10;
  totalRows = 0;
  tabHeader: {key: string; label: string; width: string}[] = [
    { key: "lovId", label: "LOV ID", width: "initial" },
    { key: "mnnId", label: "МНН ID", width: "initial" },
    { key: "id", label: "Номер розподілу", width: "initial" },
    { key: "orderDate", label: "Дата розподілу", width: "initial" },
    { key: "originalAuthorName", label: "Виконавець розподілу", width: "initial" },
    { key: "status", label: "Статус", width: "initial" },
    { key: "direction", label: "Напрям", width: "initial" },
    { key: "subDirection", label: "Піднапрям", width: "initial" },
    { key: "signs", label: "Підписи", width: "initial" },
    { key: "agreementNumber", label: "Номер договору", width: "initial" },
    { key: "mnn", label: "МНН", width: "initial" },
    { key: "dosage", label: "Дозування", width: "initial" },
    { key: "tradeName", label: "Торгова назва", width: "initial" },
    { key: "distributedQuantity", label: "Розподілена кількість", width: "initial" },
    { key: "measure", label: "Одиниця виміру", width: "initial" },
    { key: "unitPrice", label: "Вартість за одиницю, грн", width: "initial" },
    { key: "totalPrice", label: "Загальна вартість, грн", width: "initial" },
    { key: "pdv", label: "Ставка ПДВ", width: "initial" },
    { key: "totalPriceWithPDV", label: "Загальна вартість з ПДВ, грн", width: "initial" },
    { key: "deliveredQuantity", label: "Кількість розвезено", width: "initial" },
    { key: "totalDeliveredPriceWithPDV", label: "Сума розвезення з ПДВ, грн", width: "initial" },
    // { key: "deliveredAndDistributed", label: "Розвезено/Розподілено", width: "initial" },
    { key: "warehouseName", label: "Склад", width: "initial" },
    { key: "4", label: "Відмова", width: "initial" }
    // { key: "until", label: "Відтермінування до", width: "initial" }
  ];
  @ViewChild("distributionMZUTable") distributionMZUTable: Table | undefined;
  sortOrder: number | undefined | null = null;
  filterActive = true;
  filterField: string | string[] | null | undefined = "";
  tableState: TableLazyLoadEvent = {};
  content = "";
  loadingCounter = 0;
  filtersSubscriber: Subscription|null = null;
  protected readonly paginationOptions = PAGINATION_OPTIONS;

  ngOnInit(): void {

    this.loadColumnOrder();
  }

  ngOnDestroy(): void {
    this.filtersSubscriber?.unsubscribe();
  }

  saveColumnOrder() {
    localStorage.setItem("distributionMzuColumnOrder", JSON.stringify(this.tabHeader));
  }

  loadColumnOrder() {
    const savedOrder = localStorage.getItem("distributionMzuColumnOrder");
    if (savedOrder) {
      this.tabHeader = JSON.parse(savedOrder);
    }
  }

  loadData($event: TableLazyLoadEvent, resetState = false) {
    this.tableState = $event;
    this.filterField = $event.sortField;
    if (resetState) {
      if ($event.sortField) {
        this.filterActive = this.sortOrder !== -1;
      } else {
        this.filterActive = false;
      }
    }
    if (this.sortOrder === -1 && resetState) {
      this.sortOrder = null;
      this.distributionMZUTable?.reset();
    } else {
      if (!this.filtersSubscriber || this.filtersSubscriber.closed) {
        this.filtersSubscriber = this.filter.distributionsMZUSubject.subscribe(() => {
          this.getDistributions(this.selectedPageNumber, $event.sortOrder === 1 ? "asc" : "desc", $event.sortField?.toString());
        });
      } else {
        this.getDistributions(this.selectedPageNumber, $event.sortOrder === 1 ? "asc" : "desc", $event.sortField?.toString());
      }

      // this.getSupplies(this.selectedPageNumber, $event.sortOrder === 1 ? "asc" : "desc", $event.sortField?.toString());
      this.sortOrder = $event.sortOrder;
    }

    // this.tableState = $event;
    //
    // this.getDistributions(this.selectedPageNumber, $event.sortOrder === 1 ? "asc" : "desc", $event.sortField?.toString());
  }

  getDistributions(
    page: number | undefined,
    order = "desc",
    field = "id",
  ): void {
    let params = new HttpParams();
    this.selectedPageNumber = page ? page : 0;
    const sortFieldAndOrder = `${field},${order}`;
    params = params.append("page", this.selectedPageNumber - 1);
    params = params.append("size", this.pageSize);
    params = params.append("sort", sortFieldAndOrder);

    const timeoutId = setTimeout(() => {
      this.loadingCounter++;
    }, 300);

    this.http.get<{ [key: string]: any; }>(env.logisticsServiceBackend + "/logistics/v1/distributions/registry-mzu/v2", { params: this.addFilterParams(params) }).subscribe(data => {
      this.distributions = data["content"];
      this.totalRows = data["totalElements"];
      if (this.loadingCounter === 0) {
        clearTimeout(timeoutId);
      } else {
        this.loadingCounter--;
      }
    });
  }

  addFilterParams(params: HttpParams): HttpParams {
    const subscriber = this.filter.distributionsMZUSubject.subscribe(data => {
      let counter = 0;
      if (data.lovId.length) {
        params = params.append(`conditions[${counter}].fieldName`, "lovId");
        params = params.append(`conditions[${counter}].value`, data.lovId[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.mnnId.length) {
        params = params.append(`conditions[${counter}].fieldName`, "mnnId");
        params = params.append(`conditions[${counter}].value`, data.mnnId[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.number.length) {
        params = params.append(`conditions[${counter}].fieldName`, "number");
        params = params.append(`conditions[${counter}].value`, data.number[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.createdAt && data.createdAt.length) {
        const datepipe: DatePipe = new DatePipe("en-US");
        let formattedDate = datepipe.transform(new Date(data.createdAt[0]), "yyyy-MM-dd");
        params = params.append(`conditions[${counter}].fieldName`, "createdAt");
        params = params.append(`conditions[${counter}].value`, formattedDate || "");
        params = params.append(`conditions[${counter}].operator`, "GREATER_THAN_EQUALS");
        counter++;

        formattedDate = datepipe.transform(new Date(data.createdAt[1]), "yyyy-MM-dd");
        params = params.append(`conditions[${counter}].fieldName`, "createdAt");
        params = params.append(`conditions[${counter}].value`, formattedDate || "");
        params = params.append(`conditions[${counter}].operator`, "LESS_THAN_EQUALS");
        counter++;
      }
      if (data.executor.length) {
        params = params.append(`conditions[${counter}].fieldName`, "executor");
        params = params.append(`conditions[${counter}].value`, data.executor[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.status.length) {
        params = params.append(`conditions[${counter}].fieldName`, "status");
        params = params.append(`conditions[${counter}].values`, data.status.join(", "));
        params = params.append(`conditions[${counter}].operator`, "in");
        counter++;
      }
      if (data.direction.length) {
        params = params.append(`conditions[${counter}].fieldName`, "direction");
        params = params.append(`conditions[${counter}].value`, data.direction[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.subDirection.length) {
        params = params.append(`conditions[${counter}].fieldName`, "subDirection");
        params = params.append(`conditions[${counter}].value`, data.subDirection[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.signs.length) {
        params = params.append(`conditions[${counter}].fieldName`, "signs");
        params = params.append(`conditions[${counter}].value`, data.signs[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.documents.length) {
        params = params.append(`conditions[${counter}].fieldName`, "documents");
        params = params.append(`conditions[${counter}].value`, data.documents[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.mnn.length) {
        params = params.append(`conditions[${counter}].fieldName`, "mnn");
        params = params.append(`conditions[${counter}].value`, data.mnn[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.dosage.length) {
        params = params.append(`conditions[${counter}].fieldName`, "dosage");
        params = params.append(`conditions[${counter}].value`, data.dosage[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.tradeName.length) {
        params = params.append(`conditions[${counter}].fieldName`, "tradeName");
        params = params.append(`conditions[${counter}].value`, data.tradeName[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.distributedQuantity.length) {
        params = params.append(`conditions[${counter}].fieldName`, "distributedQuantity");
        params = params.append(`conditions[${counter}].value`, data.distributedQuantity[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.unitOfMeasure.length) {
        params = params.append(`conditions[${counter}].fieldName`, "unitOfMeasure");
        params = params.append(`conditions[${counter}].value`, data.unitOfMeasure[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.price.length) {
        params = params.append(`conditions[${counter}].fieldName`, "price");
        params = params.append(`conditions[${counter}].value`, data.price[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.totalPrice.length) {
        params = params.append(`conditions[${counter}].fieldName`, "totalPrice");
        params = params.append(`conditions[${counter}].value`, data.totalPrice[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.pdv.length) {
        params = params.append(`conditions[${counter}].fieldName`, "pdv");
        params = params.append(`conditions[${counter}].value`, data.pdv[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.totalPdv.length) {
        params = params.append(`conditions[${counter}].fieldName`, "totalPdv");
        params = params.append(`conditions[${counter}].value`, data.totalPdv[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.delivered.length) {
        params = params.append(`conditions[${counter}].fieldName`, "delivered");
        params = params.append(`conditions[${counter}].value`, data.delivered[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.priceOfDeliveredWithPdv.length) {
        params = params.append(`conditions[${counter}].fieldName`, "priceOfDeliveredWithPdv");
        params = params.append(`conditions[${counter}].value`, data.priceOfDeliveredWithPdv[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.distributedQuantity.length) {
        params = params.append(`conditions[${counter}].fieldName`, "distributedQuantity");
        params = params.append(`conditions[${counter}].value`, data.distributedQuantity[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.warehouse.length) {
        params = params.append(`conditions[${counter}].fieldName`, "warehouse");
        params = params.append(`conditions[${counter}].value`, data.warehouse[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.refusal.length) {
        params = params.append(`conditions[${counter}].fieldName`, "refusal");
        params = params.append(`conditions[${counter}].value`, data.refusal[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.postponed.length) {
        params = params.append(`conditions[${counter}].fieldName`, "postponed");
        params = params.append(`conditions[${counter}].value`, data.postponed[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
    });
    subscriber.unsubscribe();
    return params;
  }

  pageChange(pageNumber: number) {
    this.selectedPageNumber = pageNumber;
    this.loadData(this.tableState);
  }

  pageSizeChanged(pageSize: number) {
    this.pageSize = pageSize;
    this.selectedPageNumber = 1;
    this.loadData(this.tableState);
  }

  getFirstShowedRowIndex() {
    return this.selectedPageNumber === 1 ? 0 : (this.selectedPageNumber - 1) * this.pageSize;
  }

  goToDistribution(distributionId: string) {
    if (this.dataService.userRoleValue.getValue() === "DOZ") {
      this.router.navigate(["/distributions/doz/view/" + distributionId]);
    } else {
      this.router.navigate(["/distribution/view/" + distributionId]);
    }
  }

  getPathToStatusImg(rowElement: string): string {
    let color: string;
    switch (rowElement) {
    case "DRAFT": color = "grey"; break;
    case "PENDING_APPROVAL": color = "yellow"; break;
    case "AWAITING_DOZ_DISTRIBUTION": color = "yellow"; break;
    default: color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  getPathToRefusalImg(rowElement: string): string {
    let color: string;
    switch (rowElement) {
      case "Так": color = "red"; break;
      case "Ні": color = "green"; break;
      default: color = "yellow";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  public getVatRate(vatRate: number): string {
    if (vatRate === 0) {
      return "Без ПДВ";
    }
    return vatRate + "%";
  }

  isVisibleFilters(): boolean {
    return this.filter.distributionsMZUFilter;
  }

  handleColumnResize($event: TableColResizeEvent) {
    this.tabHeader.forEach(element => {
      if (element.label === $event.element.innerText.trim()) {
        element.width = $event.element.clientWidth + "px";
      }
    })
    this.saveColumnOrder();
  }

  getWithForColumn(key: string) {
    let width: string = "initial";
    this.tabHeader.filter(element => element.key === key).forEach(element => {
      width = element.width;
    })
    return width;
  }
}
